import { render, staticRenderFns } from "./NoLoginFooter.vue?vue&type=template&id=063e1a34"
import script from "./NoLoginFooter.vue?vue&type=script&lang=js"
export * from "./NoLoginFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports